module.exports = __webpack_public_path__ + "static/media/caroline_serious.56fe0a57.png";